import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, IEpPanelbarModel } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient, WebTrackUser } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-job-balances-grid',
  templateUrl: './epbt-fa-customer-job-balances-grid.component.html',
  styleUrls: ['./epbt-fa-customer-job-balances-grid.component.scss']
})
export class EpbtFaCustomerJobBalancesGridComponent implements OnInit {

  private _customerId;
  jobBalnces: any;
  @Input() customerId: number;

  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }
  get searchString(): string { return this._searchString; }



  @ViewChild('dateTemplate', {static: false}) dateTemplate: TemplateRef<any>;

  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 15;
  public cards: Array<IEpBtCardControlModel>;

  cardModels: IEpGridModel[] = [];
  cardModel: IEpGridModel;

  constructor(
    private client: FieldAgentClient,
    private route: ActivatedRoute,
    private router: Router,
    private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig,
    private customerService: EpbtFaCustomerService) { }

  webTrackUser: any;
  customerJobBalanceRequest: WebTrackUser;
  webtrackResult: any;
  currency: string;
  bisTrackSettings: any;
  errorMessage = false;

  ngOnInit() {
    this._customerId = this.customerId;
    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });

    // this.bisTrackSettings = this.fieldAgentService.getBisTrackSetting();
    // this.pageSize= this.bisTrackSettings.searchPageSize;
    // this.currency= this.bisTrackSettings.baseCurrency.symbol;
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bisTrackSettings = bistrackSettings;
      this.pageSize = this.bisTrackSettings.searchPageSize;
      this.currency = this.bisTrackSettings.baseCurrency.symbol;
    });
    // this.message = 'This customer has no job balance information.';
    // this.gridModel = this.getGridModel();
    this.getGridData();

    // this.fieldAgentService.getWebTrackUser().subscribe(webTrackRes => {
    //        this.webTrackUser = webTrackRes;
    //        //console.log(this.webTrackUser, 'jobbalancewebtrack id');
    //        //this.gridModel = this.getGridModel();
    //         this.getGridData();
    // });
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'customerId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: this.jobBalnces,
      columns: [
        { field: 'jobReference', title: 'JOB REFERENCE', width: 30, hidden: false },
        { field: 'balance', title: 'BALANCE', width: 40, hidden: false },
        { field: 'onOrder', title: 'ON ORDER', width: 30, hidden: false },
        { field: 'amountOwing', title: 'AMOUNT OWING', width: 20, hidden: false },
        { field: 'lastStatementAmount', title: 'LAST STATEMENT AMOUNT', width: 20, hidden: false },
        { field: 'lastStatementDiscount', title: 'LAST STATEMENT DISCOUNT', width: 20, hidden: false },
        { field: 'lastStatementNetAmount', title: 'LAST STATEMENT NET AMOUNT', width: 20, hidden: false },
        { field: 'lastStatementFinanceCharges', title: 'LAST STATEMENT FINANCE CHARGES', width: 20, hidden: false }
      ]
    };
    return model;
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else {
    return 420; // return 500;
    }
  }

  getGridData() {
    this.cardModels = [];

    this.customerJobBalanceRequest = new WebTrackUser();
    this.customerJobBalanceRequest = this.webTrackUser;
    this.customerJobBalanceRequest.customer.customerId = this.customerId;

    this.client.getCustomerJobBalances(this.customerJobBalanceRequest).subscribe(res => {
      this.jobBalnces = res;
      if (res.length == 0) {
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
      }
      // console.log(this.jobBalnces, 'jobdetails displat');
      // res.forEach(response => {

      //   let cardModel : any =
      //   {
      //     userData: {

      //       jobReference: response.jobReference,
      //       balance: response.balance,
      //       onOrder: response.onOrder,
      //       amountOwing: response.amountOwing,
      //       lastStatementAmount: response.lastStatementAmount,
      //       lastStatementDiscount: response.lastStatementDiscount,
      //       lastStatementNetAmount: response.lastStatementNetAmount,
      //       lastStatementFinanceCharges: response.lastStatementFinanceCharges
      //     }


      //   }
      //   this.cardModels.push(cardModel);
      //   });
      // console.log(this.cardModels, 'cardmodels job details');
      // this.gridModel.data = this.products;
    });


  }

}
